import React, {useEffect, useState} from 'react'
import {TrashIcon} from "@heroicons/react/24/solid";
import _ from 'lodash'
import {getSingleTheme, searchThemes} from "../services/theme-data-service";

const ThemeList = ({selectedTheme, setSelectedTheme, selectedThemeRemoved, setSelectedThemeRemoved}) => {
    const [searchText, setSearchText] = useState('');
    const [themesList, setThemesList] = useState([]);

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    const handleSelectTheme = async (theme) => {
        const existingTheme = await getSingleTheme(theme.id);
        const themeData = existingTheme.data();
        themeData.id = existingTheme.id;

        setSelectedTheme(themeData);
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                console.log({searchText})
                const themesListResult = await searchThemes(searchText);
                setThemesList(themesListResult);
                setSelectedTheme(themesListResult[0]);
            }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchText]);

    useEffect(() => {
        if (selectedThemeRemoved) {
            let currentThemesList = [...themesList];
            currentThemesList = _.filter(currentThemesList, theme => {
                return theme.id !== selectedTheme.id;
            });

            setThemesList(currentThemesList);
            setSelectedTheme(currentThemesList[0]);
            setSelectedThemeRemoved(false);
        }
    }, [selectedThemeRemoved]);

    return (
        <>

            <div className="mb-2 flex justify-between">
                <input type="text" placeholder="Search"
                       id="text"
                       name="text"
                       value={searchText}
                       onChange={handleSearchText}
                       className="h-12 w-full border border-gray-500 p-4 rounded mr-2"/>

                <button
                    onClick={() => handleClearSearch()}
                    className="rounded flex items-center justify-center border-gray-500 border bg-white text-gray-500 h-12 hover:bg-gray-500 hover:text-white">
                    <div className="p-4">
                        <TrashIcon className="h-6 w-6"/>
                    </div>
                </button>
            </div>

            <div
                className="overflow-y-scroll h-full border border-gray-400 bg-white px-4">
                <div className="py-4">
                    {themesList?.map((theme, index) => (
                        <div key={index} onClick={() => {
                            handleSelectTheme(theme)
                        }}>
                            <div
                                className={`li-item py-2 ${selectedTheme?.id === theme?.id ? 'li-item-selected' : ''}`}>
                                <span className="px-4">{index + 1}</span>{theme.startText}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </>
    )
}

export default ThemeList
